import React from "react"
import Img from "gatsby-image"
import Bobi from '../img/bobi.svg'
import Srci from '../img/srci.svg'

const Node = ({ node }) => (
  <a className="ig-post" href={`https://www.instagram.com/p/${node.id}/`}>
    <Img className="ig-photo" fluid={node.localFile.childImageSharp.fluid} fadeIn={false} loading="eager" />
    <div className="ig-meta">
      <div className="ig-likes">{node.likes}</div>
      <div className="ig-hearts"><img src={Srci} className="insta-image" alt="Likes" /></div>
    </div>
  </a>
)

export const InstagramPosts = ({ nodes }) => {
  return (
    <div className="ig-gallery">
      {nodes.edges.map(instagram => (
        <Node key={instagram.node.id} node={instagram.node} />
      ))}
    </div>
  )
}
